module.exports = __webpack_public_path__ + "static/media/42-7.b6c87721.mp3";